const possibleConnections = (pointsCount: number) => {
    return (pointsCount * (pointsCount - 1)) / 2;
};

export default possibleConnections;
